<template>
  <div class="uk-grid uk-child-width-1-1 uk-margin-top" data-uk-grid>
    <div v-if="!success">
      <template v-if="tenant.knumber === 'K10149'">
        <div class="uk-alert-warning uk-alert">
          Die Fahrzeuge im Warenkorb sind nicht reserviert!
        </div>
      </template>
      <div class="uk-card uk-card-small uk-card-default uk-box-shadow-small uk-margin-bottom">
        <div class="uk-card-header">
          <h3 class="uk-card-title">Warenkorb</h3>
        </div>
        <div class="uk-card-body">
          <ul class="uk-list uk-list-divider" v-if="cartItems.length">
            <li v-for="(item, i) in cartItems" :key="i">
              <div class="uk-alert-danger" uk-alert v-if="tenant.knumber === 'K10149' && item.vehicle && item.vehicle.reserved">
                <a class="uk-alert-close" uk-close></a>
                <p>Dieses Fahrzeug ist momentan reserviert, wir überprüfen die Verfügbarkeit und melden uns bei Ihnen.</p>
              </div>
              <div class="uk-grid" :class="{ 'uk-flex uk-flex-middle': item.isPackage }">
                <div class="uk-width-small@s" v-if="item.vehicle">
                  <router-link :to="{ name: 'vehicle-details', params: { id: item.vehicleId } }" class="uk-link-reset">
                    <img
                      v-if="item.vehicle.images && item.vehicle.images.length"
                      :src="item.vehicle.images[0]['600']"
                      :alt="item.name"
                    />
                    <img class="uk-width-1-1" v-else src="/img/placeholder.png" :alt="item.name" />
                  </router-link>
                </div>
                <div class="uk-width-small@s" v-else>
                  <div class="uk-flex uk-flex-center">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="44"
                      height="44"
                      viewBox="0 0 24 24"
                      stroke-width="1"
                      stroke="currentColor"
                      fill="none"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    >
                      <path stroke="none" d="M0 0h24v24H0z" fill="none" />
                      <polyline points="12 3 20 7.5 20 16.5 12 21 4 16.5 4 7.5 12 3" />
                      <line x1="12" y1="12" x2="20" y2="7.5" />
                      <line x1="12" y1="12" x2="12" y2="21" />
                      <line x1="12" y1="12" x2="4" y2="7.5" />
                      <line x1="16" y1="5.25" x2="8" y2="9.75" />
                    </svg>
                  </div>
                </div>
                <div class="uk-width-expand uk-padding-remove-vertical uk-padding-remove-right">
                  <div class="uk-grid uk-grid-match uk-grid-small uk-grid-divider" uk-grid>
                    <div class="uk-width-3-5@l">
                      <template v-if="item.data">
                        <p class="uk-text-bold">
                          <router-link
                            :to="{ name: 'vehicle-details', params: { id: item.vehicleId } }"
                            v-if="item.vehicle"
                            class="uk-link-reset"
                          >
                            {{ item.data.name }}
                          </router-link>
                          <template v-else>
                            {{ item.data.name }}
                          </template>
                        </p>
                        <div class="margin" v-if="item.vehicle">
                          <div class="uk-grid">
                            <div class="uk-width-1-4@s">
                              {{ item.vehicle.internalfirstregdate || item.vehicle.firstregdate }}
                            </div>
                            <div class="uk-width-1-2@s">
                              {{
                                item.vehicle.powerkw +
                                  ' kW (' +
                                  item.vehicle.powerps +
                                  ' PS) | ' +
                                  item.vehicle.fueltype
                              }}
                            </div>
                          </div>
                        </div>
                        <span v-else class="uk-label uk-label-danger uk-text-center"
                          >Fahrzeug nicht mehr verfügbar</span
                        >
                      </template>
                      <template v-else>
                        <p class="uk-text-bold">
                          {{ item.name }}
                        </p>
                        <div class="margin">{{ item.vehicleCount }} Fahrzeuge</div>
                      </template>
                    </div>
                    <prices v-if="item.vehicle" :item="item.vehicle"></prices>
                    <div class="uk-width-1-4@l uk-width-2-3@m uk-width-2-3@s uk-width-3-4" v-else>
                      <table class="uk-table">
                        <tbody>
                          <tr>
                            <td class="uk-text-bold uk-padding-remove-top uk-padding-remove-left">
                              Paket-Preis
                            </td>
                            <td class="uk-text-right@l uk-text-bold uk-padding-remove-top">{{ item.price }}</td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                    <div class="uk-width-auto@s uk-width-1-4">
                      <div class="uk-inline">
                        <router-link
                          :to="{ name: 'vehicle-details', params: { id: item.vehicleId } }"
                          v-if="item.vehicle"
                          class="uk-text-warning uk-margin-small-right uk-margin-small-bottom"
                          :uk-icon="'icon: info'"
                        ></router-link>
                        <router-link
                          v-else
                          :to="{ name: 'VehiclePackages' }"
                          class="uk-text-warning uk-margin-small-right uk-margin-small-bottom"
                          :uk-icon="'icon: info'"
                        >
                        </router-link>
                        <a
                          href="#"
                          class="uk-text-danger"
                          :uk-icon="'icon: trash'"
                          @click.prevent="removeFromCart(item)"
                        ></a>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </li>
          </ul>
          <div v-else class="uk-margin uk-text-large">
            Keine Fahrzeuge im Warenkorb
          </div>
        </div>
      </div>
      <div class="uk-alert uk-alert-danger" v-if="isOutOfStock">
        <p class="uk-text-bold">
          Folgende Fahrzeuge aus Ihrem Warenkorb sind leider nicht mehr verfügbar:
        </p>
        <ul>
          <li v-for="(vehicleId, i) in outOfStock" :key="i">
            {{ renderOutOfStockVehicle(vehicleId) }}<br />
            <a href="#" @click.prevent="removeOutOfStockFromCart(vehicleId, i)">Aus Warenkorb entfernen</a>
          </li>
        </ul>
      </div>
    </div>
    <template v-if="$can('cart', 'submit')">
      <div v-if="cartItems.length && !success">
        <ValidationObserver ref="observer" v-slot="{ handleSubmit }">
          <div class="uk-width-1-1 uk-margin-bottom" v-if="tenant.knumber === 'K10122' || tenant.knumber === 'K10151'">
            <div class="uk-flex uk-flex-right">
              <div class="uk-grid-small uk-child-width-auto uk-grid">
                <label
                  ><input class="uk-radio" type="radio" value="pickup" v-model="options.delivery" />
                  Selbstabholung</label
                >
                <label v-if="$store.state.auth.user.data.merchant.country === 'Deutschland'">
                  <input class="uk-radio" type="radio" value="shipping" v-model="options.delivery" /> 
                  Anlieferung (Nur Deutschlandweit - Ohne Insel) - (230,- € Netto pro Fahrzeug)
                  </label>
              </div>
            </div>
          </div>
          <div class="uk-width-1-1 uk-margin-bottom">
            <div class="uk-text-right">
              <div class="uk-margin">
                <ValidationProvider :rules="{ required: { allowFalse: false } }" name="agreeTOS" v-slot="{ errors }">
                  <label>
                    <input class="uk-checkbox" type="checkbox" v-model="agreeTOS" />

                    Ich stimme den
                    <a :href="tenant.agbLink" target="_blank" class="uk-link-text legal-link uk-text-bold">Allgemeinen Geschäftsbedingungen</a>
                    zu.
                  </label>
                  <p class="uk-text-danger uk-text-small uk-margin-remove" v-if="errors[0]">
                    Bitte stimmen Sie unseren AGBs zu!
                  </p>
                </ValidationProvider>
              </div>
            </div>
            <div class="uk-align-right">
              <div class="uk-inline">
                <div uk-spinner v-if="sending" class="uk-margin-small-right"></div>
                <button
                  href="#"
                  @click.prevent="handleSubmit(checkStock)"
                  class="uk-button uk-button-primary"
                  :disabled="sending"
                >
                  Kaufen
                </button>
              </div>
            </div>
          </div>
        </ValidationObserver>
      </div>
    </template>
    <div v-if="success">
      <div class="uk-card uk-card-small uk-card-default uk-box-shadow-small uk-margin-bottom">
        <div class="uk-card-header">
          <h3 class="uk-card-title">Vielen Dank für Ihren Kauf!</h3>
        </div>
        <div class="uk-card-body">
          <p class="uk-margin">
            Sie erhalten in kürze eine E-Mail mit der Kaufbestätigung!
          </p>
          <p uk-margin>
            <router-link :to="{ name: 'orders' }" class="uk-button uk-button-primary uk-margin-small-right"
              >Bestellübersicht</router-link
            >
            <router-link :to="{ name: 'VehicleIndex' }" class="uk-button uk-button-primary">Fahrzeugliste</router-link>
          </p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Prices from '@/components/vehicles/Prices.vue'
import CartService from '@/services/cart.service'
import 'izitoast/dist/css/iziToast.min.css'
import iziToast from 'izitoast/dist/js/iziToast.min.js'
import { mapGetters } from 'vuex'
import { ValidationProvider, ValidationObserver, extend } from 'vee-validate'
import { required } from 'vee-validate/dist/rules'
import { map as _map } from 'lodash'
import axios from 'axios'
import Configuration from '@/configuration'
const baseURL = Configuration.value('apiFrontend')

extend('required', {
  ...required,
  message: 'Pflichtfeld'
})

export default {
  components: {
    Prices,
    ValidationProvider,
    ValidationObserver
  },

  props: ['checkboxes'],

  data() {
    return {
      sending: false,
      success: false,
      agreeTOS: false,
      formErrors: {},
      outOfStock: [],
      isOutOfStock: false,
      options: {
        delivery: 'pickup'
      }
    }
  },
  computed: {
    ...mapGetters(['cartItems', 'tenant'])
  },

  methods: {
    async removeFromCart(item) {
      if (item.isPackage) {
        await CartService.removePackage(item.id)
      } else {
        await CartService.remove(item.id)
      }
      iziToast.success({
        title: 'OK',
        message: 'Fahrzeug aus Warenkorb entfernt!',
        timeout: 5000,
        position: 'topCenter'
      })
      this.$store.dispatch('getCart')
      this.$store.dispatch('getCartCount')
    },
    checkStock() {
      this.sending = true
      this.formErrors = {}
      this.outOfStock = []
      this.isOutOfStock = false
      CartService.checkStock().then(response => {
        _map(response.data, (v, k) => {
          if (!v) {
            this.outOfStock.push(k)
          }
        })

        if (this.outOfStock.length) {
          this.sending = false
          this.isOutOfStock = true
          return
        } else {
          this.buy()
        }
      })
    },
    buy() {
      this.sending = true
      this.formErrors = {}
      CartService.buy({ options: this.options })
        .then(response => {
          this.sending = false
          this.success = true
          this.$store.dispatch('getCartCount')
          this.downloadPdf(response.data)
        })
        .catch(error => {
          this.sending = false
          this.formErrors = error.response.data
          if (error.response.status === 400 || error.response.status === 500) {
            iziToast.error({
              title: 'Fehler',
              message: 'Fehler bei der Bestellung!',
              timeout: 5000,
              position: 'topCenter'
            })
          }
        })
    },
    renderOutOfStockVehicle(vehicleId) {
      const vehicle = this.getVehicleFromVehicleId(vehicleId)

      if (typeof vehicle !== 'undefined') {
        return `${vehicle.data.name} (Fahrzeug-Nr.: ${vehicle.vehicle.carId})`
      }

      return null
    },
    removeOutOfStockFromCart(vehicleId, index) {
      const vehicle = this.getVehicleFromVehicleId(vehicleId)
      if (vehicle) {
        this.removeFromCart(vehicle.id)
        this.outOfStock.splice(index, 1)
        if (!this.outOfStock.length) {
          this.isOutOfStock = false
        }
      } else {
        return
      }
    },
    getVehicleFromVehicleId(vehicleId) {
      return this.cartItems.find(i => i.vehicle.carId === vehicleId)
    },
    downloadPdf(sale) {
      axios({
        url: `${baseURL}/sale/print/${sale.id}`,
        method: 'GET',
        responseType: 'blob' // important
      }).then(response => {
        const url = window.URL.createObjectURL(new Blob([response.data]))
        const link = document.createElement('a')
        link.href = url
        link.setAttribute('download', `Bestellschein-${sale.number}.pdf`)
        document.body.appendChild(link)
        link.click()
      })
    }
  }
}
</script>
